import React from 'react';

import { useTheme } from "@mui/material/styles";
import { Box, Card, Stack, Typography } from "@mui/material";

const InfoField = ({ theme, title, metaInfo }) => (
  <Stack
    sx={{
      display: "flex",
      flexDirection: "row",
      justifyContent: "space-between",
      alignItems: "center",
      color: theme.palette.primary.main,
      marginBottom: 2,
      margin: "8px",
      padding: "8px",
    }}
  >
    <Typography
      sx={{
        margin: 0,
        color: theme.palette.primary.main,
        fontWeight: theme.typography.customFontWeight[0],
        fontSize: theme.typography.customFontSize[3],
        textAlign: "left",
      }}
    >
      {title}
    </Typography>
    {
      metaInfo && <Box sx={{ display: "flex", alignItems: "stretch" }}>
        {metaInfo}
      </Box>
    }
  </Stack>
)

const StackField = ({ theme, title, option, metaInfo }) => (
  <Stack
    sx={{
      display: "flex",
      flexDirection: "row",
      justifyContent: "space-between",
      alignItems: "center",
      borderBottom: `1px solid ${theme.palette.primary.borderGreyPrimary}`,
      color: theme.palette.primary.main,
      marginBottom: 2,
      margin: "8px",
      padding: "8px",
    }}
  >
    <Typography
      sx={{
        margin: 0,
        color: theme.palette.primary.main,
        fontWeight: theme.typography.customFontWeight[1],
        fontSize: theme.typography.customFontSize[3],
        textAlign: "left",
      }}
    >
      {title}
    </Typography>
    {option}
    {
      metaInfo && <Box sx={{ display: "flex", alignItems: "stretch" }}>
        {metaInfo?.icon}
        <Typography
          sx={{
            marginLeft: "5px",
            color: theme.palette.primary.main,
            fontSize: theme.typography.customFontSize[2],
          }}>
          {metaInfo.info}
        </Typography>
      </Box>
    }
  </Stack>
)

const InfoCardField = ({ width, mode = "info", title, option, metaInfo, infoData }) => {
  const theme = useTheme();

  const modeMap = {
    info: <InfoField theme={theme} title={title} metaInfo={metaInfo} />,
    stack: <StackField theme={theme} title={title} option={option} metaInfo={metaInfo} />,
  };

  return (
    <Card sx={{ width }}>
      {modeMap[mode]}
      {infoData}
    </Card>
  )
};

export default InfoCardField;